//solar panels

export const getProductsWithSuppliers = `
  query GetProductsWithSuppliers(
    $productKrns: [String!]!
    $productCategory: ProductCategory!
  ) {
    productsWithSuppliers(
      productKrns: $productKrns
      productCategory: $productCategory
    ) {
      products {
        id
        krn
        name
        orderType
        description
        state
        productType
        productCategory
        externalId
        productSupplierId
        affiliateUrl
        testScores {
          source
          score
        }
        insuranceCardUrl
        termsAndConditionsUrl
        productIncentives {
          productIncentiveDetailsKrn
        }
        correspondingMoneyViewExternalId
      }
      productIncentiveDetails {
        krn
        productIncentiveType
        label
      }
      suppliers {
        id
        krn
        name
        about
        legalName
        externalIds {
          providerKrn
          externalSupplierId
        }
        porCompany
        state
        features {
          name
          value
          productCategory
        }
        nameLogoUrl
        addresses {
          id
          addressType
          city
          country
          houseNumber
          houseNumberAddition
          postalCode
          street
        }
        informationContacts {
          id
          type
          replyNumber
          phoneNumber
          emailAddress
        }
        advantages {
          description
          productCategory
        }
        disadvantages {
          description
          productCategory
        }
        taskDivisions {
          clientName
          value
          productCategory
          name
        }
        howItWorks {
          clientName
          productCategory
          typeName
          value
        }
        sellingPoints {
          productCategory
          value
          clientName
          description
          orderType
          sellingPointType
        }
        sustainabilityScore {
          score
          source
        }
      }
    }
  }
`;

export default getProductsWithSuppliers;
